const SphereLogoColor = Object.freeze({
    black: "black",
    blue: "blue",
    white: "white"
});

export default SphereLogoColor;
